import { RootState } from 'redux/store';
import { createSelector } from 'reselect';
import { selectAllGadgets, selectGadgetById } from './gadget-update.adapter';

const selectSelf = (state: RootState) => state;
const getGadgetState = createSelector(selectSelf, (state) => state.gadgetUpdate);

const getLoaded = createSelector(
  getGadgetState,
  (state) => state.loaded,
);

const getEntities = createSelector(
  selectSelf,
  selectAllGadgets,
);

const getSelectedEntity = createSelector(
  selectSelf,
  (state: RootState) => selectGadgetById(state, state.gadgetUpdate.selectedId),
);

const getTouched = createSelector(
  getGadgetState,
  (state) => state.touched,
);

export const gadgetUpdateQuery = {
  getLoaded,
  getEntities,
  getSelectedEntity,
  getTouched,
};
